export default __webpack_public_path__ + "static/media/about-us-3.cc05c77a.png";